module.exports = __webpack_public_path__ + "static/media/banner_midknitecreation.3fdd896d.png";